import { DefaultersRotateFilterForm } from "./rotate-filter-form"
import { DefaultersRotateTable } from "./rotate-table"

export const DefaultersRotateTabContent = () => {
  return (
    <section className="flex flex-1 flex-col gap-4">
      <DefaultersRotateFilterForm />
      <DefaultersRotateTable />
    </section>
  )
}
